(function () {
  var recommendationsLoadId = 0;
  var skipSectionRefreshOnce = false;

  function getDrawer() {
    return document.getElementById('MinicartDrawer');
  }

  function formatMoney(cents) {
    var formatted;

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      formatted = window.Shopify.formatMoney(cents);
    } else {
      formatted = (cents / 100).toFixed(2);
    }

    var drawer = getDrawer();
    var symbol = (drawer && drawer.dataset.currencySymbol) || '';
    var code = (drawer && drawer.dataset.currencyCode) || '';

    if (symbol === '$') {
      if (formatted.indexOf(symbol) === -1) {
        formatted = symbol + formatted;
      }

      if (code && formatted.indexOf(code) === -1) {
        formatted = formatted + ' ' + code;
      }
    }

    return formatted;
  }

  function updateShippingRow(drawer) {
    var threshold = parseInt(drawer.dataset.freeShippingThreshold, 10);
    var subtotalEl = drawer.querySelector('[data-minicart-subtotal-cents]');
    var shippingEl = drawer.querySelector('[data-minicart-shipping-value]');

    if (!subtotalEl || !shippingEl || !Number.isFinite(threshold)) return;

    var subtotal = parseInt(subtotalEl.dataset.minicartSubtotalCents, 10) || 0;
    var freeLabel = drawer.dataset.shippingFreeLabel || 'Free';
    var calculatedLabel = drawer.dataset.shippingCalculatedLabel || 'Calculated at checkout';

    shippingEl.textContent = subtotal >= threshold ? freeLabel : calculatedLabel;
  }

  function getShopifyRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  }

  function getFirstProductId(drawer) {
    var line = drawer.querySelector('.cart-line-minicart[data-product-id]');
    return line ? line.dataset.productId : null;
  }

  function getCartProductIds(drawer) {
    var ids = {};

    drawer.querySelectorAll('.cart-line-minicart[data-product-id]').forEach(function (line) {
      var id = String(line.dataset.productId || '');
      if (id) ids[id] = true;
    });

    return ids;
  }

  function getRecommendationProductId(item) {
    if (!item) return '';
    if (item.id != null && item.id !== '') return String(item.id);
    if (item.product_id != null && item.product_id !== '') return String(item.product_id);
    if (item.productId != null && item.productId !== '') return String(item.productId);
    return '';
  }

  function excludeProductsAlreadyInCart(drawer, items) {
    var inCart = getCartProductIds(drawer);

    return (items || []).filter(function (item) {
      var id = getRecommendationProductId(item);
      return !id || !inCart[id];
    });
  }

  function normalizeImageUrl(url) {
    if (!url) return '';

    if (url.indexOf('//') === 0) {
      return 'https:' + url;
    }

    return url;
  }

  function resolveProductImage(product) {
    var image = product.featured_image || product.image || '';

    if (image && typeof image === 'object') {
      image = image.src || image.url || '';
    }

    return normalizeImageUrl(image);
  }

  function getTileImageUrl(tile) {
    var imageEl = tile.querySelector('.product-tile__gallery img');

    if (!imageEl) return '';

    var src = imageEl.getAttribute('src');

    if (src && src.indexOf('placeholder') === -1) {
      return normalizeImageUrl(src);
    }

    var srcset = imageEl.getAttribute('srcset');

    if (srcset) {
      var parts = srcset.split(',');
      var lastPart = parts[parts.length - 1].trim().split(/\s+/)[0];

      if (lastPart) {
        return normalizeImageUrl(lastPart);
      }
    }

    return normalizeImageUrl(imageEl.currentSrc || imageEl.src || '');
  }

  function extractShortDescriptionText(value) {
    if (!value) return '';

    if (typeof value === 'object') {
      if (typeof value.value === 'string') {
        value = value.value;
      } else if (Array.isArray(value.children)) {
        value = value.children
          .map(function (child) {
            return extractShortDescriptionText(child);
          })
          .join(' ');
      } else {
        return '';
      }
    }

    return String(value)
      .replace(/<[^>]+>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getProductShortDescription(product) {
    return extractShortDescriptionText(product.short_description || product.shortDescription || '');
  }

  function escapeRecommendationHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getRecommendationsAddLabel(drawer) {
    return (drawer && drawer.dataset.recommendationsAddLabel) || 'Add';
  }

  function getRecommendationVariantId(product) {
    if (product.variant_id) return product.variant_id;
    if (product.variantId) return product.variantId;

    if (product.variants && product.variants.length) {
      var availableVariant = product.variants.find(function (variant) {
        return variant.available;
      });

      return (availableVariant || product.variants[0]).id;
    }

    return null;
  }

  function isRecommendationAvailable(product) {
    if (product.available === false) return false;
    if (product.available === true) return true;

    if (product.variants && product.variants.length) {
      return product.variants.some(function (variant) {
        return variant.available;
      });
    }

    return true;
  }

  function buildRecommendationItemHtml(options) {
    var url = options.url || '#';
    var image = options.image ? normalizeImageUrl(options.image) : '';
    var variantId = options.variantId || '';
    var addLabel = options.addLabel || 'Add';
    var canAdd = variantId && options.available !== false;
    var mediaHtml =
      '<div class="minicart__recommendations-media">' +
      (image
        ? '<a href="' +
          url +
          '" class="minicart__recommendations-media-link"><img src="' +
          image +
          '" alt="" loading="lazy" class="minicart__recommendations-image"></a>'
        : '') +
      '</div>';
    var addButtonHtml = canAdd
      ? '<button type="button" class="minicart__recommendations-add" data-minicart-recommendations-add data-variant-id="' +
        variantId +
        '" aria-label="' +
        addLabel +
        '"><svg class="plus" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path fill="currentColor" d="M10.25 21V13.75H3V10.25H10.25V3H13.75V10.25H21V13.75H13.75V21H10.25Z"></path></svg></button>'
      : '';

    return (
      '<div class="minicart__recommendations-item">' +
      mediaHtml +
      '<div class="minicart__recommendations-body">' +
      '<a href="' +
      url +
      '" class="minicart__recommendations-details"><span class="minicart__recommendations-name">' +
      (options.title || '') +
      '</span>' +
      buildRecommendationSubtextHtml(options) +
      '</a><div class="minicart__recommendations-meta"><span class="minicart__recommendations-price">' +
      (options.price || '') +
      '</span>' +
      addButtonHtml +
      '</div></div>' +
      '</div>'
    );
  }

  function getRecommendationSku(product) {
    if (!product) return '';
    if (product.sku) return extractShortDescriptionText(product.sku);

    if (product.variants && product.variants.length) {
      return extractShortDescriptionText(product.variants[0].sku || '');
    }

    return '';
  }

  function buildRecommendationSubtextHtml(options) {
    var html = '';
    var shortDescription = extractShortDescriptionText(options.short_description || options.description || '');
    var sku = extractShortDescriptionText(options.sku || '');

    if (shortDescription) {
      html +=
        '<div class="minicart__recommendations-description">' + escapeRecommendationHtml(shortDescription) + '</div>';
    }

    if (sku && sku !== shortDescription) {
      html += '<div class="minicart__recommendations-description">' + escapeRecommendationHtml(sku) + '</div>';
    }

    return html;
  }

  function buildRecommendationSlideFromData(slideData, addLabel) {
    var slide = document.createElement('div');
    slide.className = 'swiper-slide minicart__recommendations-slide';
    var productId = getRecommendationProductId(slideData);
    if (productId) slide.setAttribute('data-product-id', productId);

    slide.innerHTML = buildRecommendationItemHtml({
      url: slideData.url,
      image: slideData.image,
      title: slideData.title,
      price: slideData.price,
      short_description: slideData.short_description || slideData.description || '',
      sku: slideData.sku || '',
      variantId: slideData.variant_id,
      available: slideData.available,
      addLabel: addLabel,
    });

    return slide;
  }

  function buildRecommendationSlide(product, addLabel) {
    var slide = document.createElement('div');
    slide.className = 'swiper-slide minicart__recommendations-slide';
    var productId = getRecommendationProductId(product);
    if (productId) slide.setAttribute('data-product-id', productId);

    var image = resolveProductImage(product);
    var price = product.price_min != null ? product.price_min : product.price;
    var url =
      product.url ||
      getShopifyRoot() + 'products/' + (product.handle || '');

    if (url.indexOf('//') === 0) {
      url = 'https:' + url;
    }

    slide.innerHTML = buildRecommendationItemHtml({
      url: url,
      image: image,
      title: product.title || '',
      price: product.price_label || formatMoney(price),
      short_description: getProductShortDescription(product),
      sku: getRecommendationSku(product),
      variantId: getRecommendationVariantId(product),
      available: isRecommendationAvailable(product),
      addLabel: addLabel,
    });

    return slide;
  }

  function getPerView(slider) {
    if (!slider) return window.innerWidth >= 1025 ? 2 : 1.2;

    return window.innerWidth >= 1025
      ? parseFloat(slider.dataset.desktopSlides) || 2
      : parseFloat(slider.dataset.mobileSlides) || 1.2;
  }

  function hideRecommendationsProgress(drawer) {
    var progress = drawer.querySelector('[data-minicart-recommendations-progress]');
    if (progress) progress.hidden = true;
  }

  function setupRecommendationsProgress(drawer) {
    var carousel = drawer.querySelector('[data-minicart-recommendations-carousel]');
    var progress = drawer.querySelector('[data-minicart-recommendations-progress]');
    var thumb = drawer.querySelector('[data-minicart-recommendations-progress-thumb]');
    var slider = carousel && carousel.querySelector('.carousel__slider-wrapper');

    if (!progress || !thumb || !slider || !slider.swiper) {
      hideRecommendationsProgress(drawer);
      return;
    }

    var swiper = slider.swiper;
    var perView = getPerView(slider);

    if (swiper.slides.length <= perView) {
      hideRecommendationsProgress(drawer);
      return;
    }

    function updateProgress() {
      var maxTranslate = Math.abs(swiper.maxTranslate());

      if (maxTranslate <= 0) {
        hideRecommendationsProgress(drawer);
        return;
      }

      var thumbWidth = Math.max((perView / swiper.slides.length) * 100, 8);
      var progressRatio = Math.min(Math.abs(swiper.translate) / maxTranslate, 1);

      progress.hidden = false;
      thumb.style.width = thumbWidth + '%';
      thumb.style.left = progressRatio * (100 - thumbWidth) + '%';
    }

    if (progress._minicartProgressHandler) {
      swiper.off('slideChange', progress._minicartProgressHandler);
      swiper.off('setTranslate', progress._minicartProgressHandler);
      swiper.off('resize', progress._minicartProgressHandler);
    }

    if (progress._minicartResizeHandler) {
      window.removeEventListener('resize', progress._minicartResizeHandler);
    }

    progress._minicartProgressHandler = updateProgress;
    progress._minicartResizeHandler = function () {
      perView = getPerView(slider);
      swiper.update();
      updateProgress();
    };

    swiper.on('slideChange', updateProgress);
    swiper.on('setTranslate', updateProgress);
    swiper.on('resize', progress._minicartResizeHandler);
    window.addEventListener('resize', progress._minicartResizeHandler);

    updateProgress();
  }

  function setupRecommendationsProgressWithRetry(drawer, attempt) {
    var carousel = drawer.querySelector('[data-minicart-recommendations-carousel]');
    var slider = carousel && carousel.querySelector('.carousel__slider-wrapper');

    if (slider && slider.swiper) {
      slider.swiper.update();
      setupRecommendationsProgress(drawer);
      return;
    }

    if ((attempt || 0) < 40) {
      setTimeout(function () {
        setupRecommendationsProgressWithRetry(drawer, (attempt || 0) + 1);
      }, 50);
    }
  }

  function destroyRecommendationsCarousel(drawer) {
    var carousel = drawer.querySelector('[data-minicart-recommendations-carousel]');
    if (!carousel) return;

    var slider = carousel.querySelector('.carousel__slider-wrapper');
    if (slider && slider.swiper && typeof slider.swiper.destroy === 'function') {
      slider.swiper.destroy(true, true);
      slider.classList.remove('swiper-initialized');
    }
  }

  function initRecommendationsCarousel(drawer, attempt) {
    var carousel = drawer.querySelector('[data-minicart-recommendations-carousel]');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    if (!drawer.classList.contains('open')) return;

    if (window.dAgency && typeof window.dAgency.initCarousel === 'function') {
      destroyRecommendationsCarousel(drawer);
      window.dAgency.initCarousel(carousel);

      var slider = carousel.querySelector('.carousel__slider-wrapper');

      function updateSwiper() {
        if (slider && slider.swiper) {
          slider.swiper.update();
        }
      }

      updateSwiper();
      requestAnimationFrame(updateSwiper);
      setTimeout(function () {
        updateSwiper();
        setupRecommendationsProgressWithRetry(drawer, 0);
      }, 150);
      return;
    }

    if ((attempt || 0) < 40) {
      setTimeout(function () {
        initRecommendationsCarousel(drawer, (attempt || 0) + 1);
      }, 50);
    }
  }

  function refreshRecommendationsCarousel(drawer) {
    var carousel = drawer.querySelector('[data-minicart-recommendations-carousel]');
    if (!carousel || carousel.querySelectorAll('.swiper-slide').length <= 1) {
      hideRecommendationsProgress(drawer);
      return;
    }

    initRecommendationsCarousel(drawer);
    setupRecommendationsProgressWithRetry(drawer, 0);
  }

  function parseRecommendationsHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var slides = doc.querySelectorAll('[data-minicart-recommendation-slide]');

    return Array.from(slides).map(function (slide) {
      return {
        id: slide.dataset.productId || '',
        product_id: slide.dataset.productId || '',
        title: slide.dataset.title || '',
        url: slide.dataset.url || '#',
        image: slide.dataset.image || '',
        price: slide.dataset.price || '',
        description: slide.dataset.description || '',
        short_description: slide.dataset.shortDescription || slide.dataset.description || '',
        sku: slide.dataset.sku || '',
        variant_id: slide.dataset.variantId || '',
        available: slide.dataset.available !== 'false',
      };
    });
  }

  function renderRecommendationsFromSlides(drawer, slideDataList) {
    var container = drawer.querySelector('[data-minicart-recommendations]');
    var track = drawer.querySelector('[data-minicart-recommendations-track]');
    if (!container || !track || !getFirstProductId(drawer)) return;

    slideDataList = excludeProductsAlreadyInCart(drawer, slideDataList);
    track.innerHTML = '';

    if (!slideDataList.length) {
      container.classList.add('hidden');
      return;
    }

    slideDataList.forEach(function (slideData) {
      track.appendChild(buildRecommendationSlideFromData(slideData, getRecommendationsAddLabel(drawer)));
    });

    container.classList.remove('hidden');
    initRecommendationsCarousel(drawer);
  }

  function getRecommendationsSource(drawer) {
    var source = drawer.dataset.recommendationsSource;
    return source || 'custom';
  }

  function getCustomProducts(drawer) {
    var script = drawer.querySelector('[data-minicart-custom-products]');

    if (!script) return [];

    try {
      return JSON.parse(script.textContent) || [];
    } catch (error) {
      return [];
    }
  }

  function hasRecommendationSlides(drawer) {
    var track = drawer.querySelector('[data-minicart-recommendations-track]');
    return !!(track && track.querySelector('.minicart__recommendations-slide'));
  }

  function removeInCartRecommendationSlides(drawer) {
    var inCart = getCartProductIds(drawer);
    var track = drawer.querySelector('[data-minicart-recommendations-track]');
    if (!track) return 0;

    Array.from(track.querySelectorAll('.minicart__recommendations-slide[data-product-id]')).forEach(function (slide) {
      if (inCart[String(slide.dataset.productId || '')]) {
        slide.remove();
      }
    });

    if (!track.querySelector('.minicart__recommendations-slide')) {
      hideRecommendationsContainer(drawer);
      return 0;
    }

    return track.querySelectorAll('.minicart__recommendations-slide').length;
  }

  function cartHasVisibleItems(drawer) {
    if (drawer.querySelector('.cart-line-minicart')) return true;

    var footer = drawer.querySelector('.minicart__footer');
    return !!(footer && !footer.classList.contains('hidden'));
  }

  function showRecommendationsContainer(drawer) {
    var container = drawer.querySelector('[data-minicart-recommendations]');
    if (container) container.classList.remove('hidden');
  }

  function hideRecommendationsContainer(drawer) {
    var container = drawer.querySelector('[data-minicart-recommendations]');
    if (container) container.classList.add('hidden');
  }

  function parseRefreshResponse(text, sectionId) {
    if (!text) return '';

    try {
      var json = JSON.parse(text);

      if (json && sectionId && json[sectionId]) {
        return json[sectionId];
      }

      if (json && typeof json === 'object') {
        var keys = Object.keys(json);
        if (keys.length === 1) {
          return json[keys[0]];
        }
      }
    } catch (error) {}

    return text;
  }

  function installMinicartSectionFetchPatch() {
    if (!window.fetch || window.fetch.__minicartSectionPatch) return;

    var originalFetch = window.fetch;

    window.fetch = function (input, init) {
      var method = (init && init.method) || (typeof Request !== 'undefined' && input instanceof Request && input.method) || 'GET';

      if (String(method).toUpperCase() !== 'GET') {
        return originalFetch.apply(this, arguments);
      }

      var href = typeof input === 'string' ? input : input && input.url ? input.url : '';
      var drawer = getDrawer();
      var sectionId = drawer && drawer.dataset.sectionId;

      if (!href || href.indexOf('sections=') === -1 || !sectionId || href.indexOf(sectionId) === -1) {
        return originalFetch.apply(this, arguments);
      }

      return originalFetch.apply(this, arguments).then(function (response) {
        return response.text().then(function (text) {
          return new Response(parseRefreshResponse(text, sectionId), {
            status: response.status,
            statusText: response.statusText,
            headers: { 'Content-Type': 'text/html' },
          });
        });
      });
    };

    window.fetch.__minicartSectionPatch = true;
  }

  installMinicartSectionFetchPatch();

  function getFallbackProducts(drawer) {
    var script = drawer.querySelector('[data-minicart-fallback-products]');

    if (!script) return [];

    try {
      return JSON.parse(script.textContent) || [];
    } catch (error) {
      return [];
    }
  }

  function renderRecommendations(drawer, products, options) {
    var container = drawer.querySelector('[data-minicart-recommendations]');
    var track = drawer.querySelector('[data-minicart-recommendations-track]');
    var skipProductCheck = options && options.skipProductCheck;

    if (!container || !track) return;
    if (!skipProductCheck && !getFirstProductId(drawer)) return;

    products = excludeProductsAlreadyInCart(drawer, products);

    if (!products.length) {
      track.innerHTML = '';
      hideRecommendationsContainer(drawer);
      return;
    }

    track.innerHTML = '';

    products.forEach(function (product) {
      track.appendChild(buildRecommendationSlide(product, getRecommendationsAddLabel(drawer)));
    });

    showRecommendationsContainer(drawer);
    initRecommendationsCarousel(drawer);
  }

  function parseProductsFromRecommendationsSection(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var tiles = doc.querySelectorAll('.product-tile__container');
    var products = [];

    tiles.forEach(function (tile) {
      var link = tile.querySelector('.product-tile__title, .product-tile__gallery');
      var titleEl = tile.querySelector('.product-tile__title');
      var descEl = tile.querySelector('.product-tile__description');
      var priceEl = tile.querySelector('.product-tile__price, [data-product-price]');
      var variantInput = tile.querySelector('input[name="id"], select[name="id"]');

      if (!link) return;

      products.push({
        id: tile.dataset.productId || '',
        title: titleEl ? titleEl.textContent.trim() : '',
        url: link.getAttribute('href') || '#',
        featured_image: getTileImageUrl(tile),
        short_description: descEl ? descEl.innerHTML.trim() : '',
        price_min: priceEl ? parseInt(priceEl.dataset.value || '0', 10) : 0,
        price_label: priceEl ? priceEl.textContent.trim() : '',
        variant_id: variantInput ? variantInput.value : '',
      });
    });

    return products;
  }

  function loadRecommendationsFromJson(drawer, productId) {
    var baseUrl = drawer.dataset.recommendationsUrl;
    if (!baseUrl) {
      renderRecommendations(drawer, getFallbackProducts(drawer));
      return;
    }

    var url =
      baseUrl +
      (baseUrl.indexOf('?') === -1 ? '?' : '&') +
      'product_id=' +
      encodeURIComponent(productId) +
      '&limit=8&intent=related';

    if (url.indexOf('.json') === -1) {
      url = url.replace(/\/?$/, '.json').replace('.json?', '.json?');
    }

    fetch(url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Recommendations request failed');
        }
        return response.json();
      })
      .then(function (data) {
        var products = (data && data.products) || [];

        if (!products.length) {
          renderRecommendations(drawer, getFallbackProducts(drawer));
          return;
        }

        renderRecommendations(drawer, products);
      })
      .catch(function () {
        renderRecommendations(drawer, getFallbackProducts(drawer));
      });
  }

  function loadRecommendationsFromMinicartSection(drawer, productId) {
    var root = getShopifyRoot();
    var url =
      root +
      'recommendations/products?product_id=' +
      encodeURIComponent(productId) +
      '&limit=8&intent=related&section_id=minicart-recommendations';

    return fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var slideDataList = parseRecommendationsHtml(html);

        if (!slideDataList.length) {
          throw new Error('No minicart recommendation slides');
        }

        renderRecommendationsFromSlides(drawer, slideDataList);
      });
  }

  function loadRecommendationsFromSection(drawer, productId) {
    var root = getShopifyRoot();
    var url =
      root +
      'recommendations/products?product_id=' +
      encodeURIComponent(productId) +
      '&limit=8&intent=related&section_id=product-recommendations';

    return fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var products = parseProductsFromRecommendationsSection(html);

        if (!products.length) {
          throw new Error('No recommendation tiles');
        }

        renderRecommendations(drawer, products);
      });
  }

  function loadRecommendations(drawer) {
    var container = drawer.querySelector('[data-minicart-recommendations]');
    if (!container) return;

    if (!cartHasVisibleItems(drawer)) {
      hideRecommendationsContainer(drawer);
      return;
    }

    showRecommendationsContainer(drawer);

    if (getRecommendationsSource(drawer) === 'custom') {
      var customProducts = getCustomProducts(drawer);

      if (customProducts.length) {
        renderRecommendations(drawer, customProducts, { skipProductCheck: true });
        return;
      }

      if (hasRecommendationSlides(drawer)) {
        if (removeInCartRecommendationSlides(drawer)) {
          initRecommendationsCarousel(drawer);
        }
      }

      return;
    }

    var productId = getFirstProductId(drawer);
    if (!productId) {
      if (!hasRecommendationSlides(drawer)) {
        hideRecommendationsContainer(drawer);
      }
      return;
    }

    var loadId = ++recommendationsLoadId;

    function isCurrentLoad() {
      return loadId === recommendationsLoadId;
    }

    loadRecommendationsFromMinicartSection(drawer, productId)
      .catch(function () {
        if (!isCurrentLoad()) return Promise.reject(new Error('stale'));
        return loadRecommendationsFromSection(drawer, productId);
      })
      .catch(function (error) {
        if (!isCurrentLoad() || (error && error.message === 'stale')) return;
        loadRecommendationsFromJson(drawer, productId);
      });
  }

  function waitForDrawerRefresh(drawer, callback, attempt) {
    var productId = getFirstProductId(drawer);
    var isLoading = drawer.classList.contains('loading');
    var isCustom = getRecommendationsSource(drawer) === 'custom';
    var hasCartContent =
      drawer.querySelector('.cart-line-minicart') || drawer.querySelector('.cart-line-group');
    var readyForCustom = isCustom && (hasCartContent || hasRecommendationSlides(drawer));

    if ((!isLoading && productId) || (!isLoading && readyForCustom)) {
      callback();
      return;
    }

    if ((attempt || 0) < 60) {
      setTimeout(function () {
        waitForDrawerRefresh(drawer, callback, (attempt || 0) + 1);
      }, 50);
    }
  }

  function drawerHasCartLines(drawer) {
    return !!(getFirstProductId(drawer) || drawer.querySelector('.cart-line-minicart'));
  }

  function waitForCartUiSettle(drawer, callback) {
    var sawLoading = drawer.classList.contains('loading');
    var ticks = 0;

    function check() {
      ticks += 1;

      if (drawer.classList.contains('loading')) {
        sawLoading = true;
      }

      if (sawLoading && !drawer.classList.contains('loading')) {
        callback();
        return;
      }

      if (!sawLoading && drawerHasCartLines(drawer) && ticks >= 2) {
        callback();
        return;
      }

      if (!sawLoading && ticks >= 12) {
        callback();
        return;
      }

      if (ticks >= 80) {
        callback();
        return;
      }

      setTimeout(check, 50);
    }

    setTimeout(check, 0);
  }

  function handleCartChange() {
    var drawer = getDrawer();
    if (!drawer) return;

    waitForCartUiSettle(drawer, function () {
      var skipRefresh = skipSectionRefreshOnce;
      skipSectionRefreshOnce = false;

      var next =
        skipRefresh || drawerHasCartLines(drawer) ? Promise.resolve() : refreshDrawer(drawer);

      next.then(function () {
        reinitMinicartCore(drawer);
        updateShippingRow(drawer);
        loadRecommendations(drawer);

        if (drawer.classList.contains('open')) {
          refreshRecommendationsCarousel(drawer);
        }
      });
    });
  }

  function debounce(fn, wait) {
    var timeout;

    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function groupCartLines(drawer) {
    var inner = drawer.querySelector('.modal__body-inner');
    if (!inner) return;

    var insertBefore = inner.querySelector('.minicart__empty-cart');
    var wrappers = Array.from(
      drawer.querySelectorAll('.cart-line__wrapper:not(.minicart__hidden-engraving)')
    );
    var groups = {};

    inner.querySelectorAll('.cart-line-group').forEach(function (groupEl) {
      groupEl.remove();
    });

    wrappers.forEach(function (wrapper) {
      var groupId = wrapper.dataset.group || 'default';
      if (!groups[groupId]) groups[groupId] = [];
      groups[groupId].push(wrapper);
    });

    Object.keys(groups).forEach(function (groupId) {
      var groupEl = document.createElement('div');
      groupEl.classList.add('cart-line-group');
      groupEl.dataset.groupId = groupId;
      groups[groupId].forEach(function (wrapper) {
        groupEl.appendChild(wrapper);
      });

      if (insertBefore) {
        inner.insertBefore(groupEl, insertBefore);
      } else {
        inner.appendChild(groupEl);
      }
    });
  }

  function initNumberField(plusBtn, minusBtn, field) {
    var min = field.dataset.min ? parseInt(field.dataset.min, 10) : null;
    var max = field.dataset.max ? parseInt(field.dataset.max, 10) : null;
    var current = parseInt(field.value, 10) || 1;

    function setValue(value) {
      current = Math.max(min != null ? min : -Infinity, Math.min(max != null ? max : Infinity, value));
      field.value = current;

      if (min != null) minusBtn.disabled = current <= min;
      if (max != null) plusBtn.disabled = current >= max;
    }

    setValue(current);

    plusBtn.addEventListener('click', function (event) {
      event.preventDefault();
      setValue(current + 1);
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });

    minusBtn.addEventListener('click', function (event) {
      event.preventDefault();
      setValue(current - 1);
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  var drawerRefreshId = 0;

  function getSectionsPayload(drawer) {
    var sectionId = drawer && drawer.dataset.sectionId;
    if (!sectionId) return {};

    return {
      sections: sectionId,
      sections_url: window.location.pathname + window.location.search,
    };
  }

  function getSectionHtmlFromCart(cart, sectionId) {
    if (!cart || !cart.sections) return '';
    if (sectionId && cart.sections[sectionId]) return cart.sections[sectionId];

    var keys = Object.keys(cart.sections);
    return keys.length ? cart.sections[keys[0]] : '';
  }

  function parseJsonResponse(response) {
    return response.json().then(function (data) {
      if (!response.ok) {
        throw new Error((data && (data.description || data.message)) || 'Could not update cart');
      }
      return data;
    });
  }

  function postCartChange(key, quantity, drawer) {
    return fetch(getCartChangeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(
        Object.assign(
          {
            id: key,
            quantity: quantity,
          },
          getSectionsPayload(drawer)
        )
      ),
    }).then(parseJsonResponse);
  }

  function postCartUpdates(updates, drawer) {
    return fetch(getShopifyRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(Object.assign({ updates: updates }, getSectionsPayload(drawer))),
    }).then(parseJsonResponse);
  }

  function getRemoveKeysForLine(line, drawer) {
    var keys = [];
    if (!line || !line.dataset.key) return keys;

    keys.push(line.dataset.key);

    if (!line.hasAttribute('data-master-product')) return keys;

    var group = line.closest('.cart-line-group');
    var engravingLine = group && group.querySelector('[data-engraving]');

    if (!engravingLine && line.dataset.group) {
      engravingLine = drawer.querySelector(
        '.minicart__hidden-engraving[data-engraving][data-group="' + line.dataset.group + '"]'
      );
    }

    if (engravingLine && engravingLine.dataset.key && keys.indexOf(engravingLine.dataset.key) === -1) {
      keys.push(engravingLine.dataset.key);
    }

    return keys;
  }

  function applyCartChange(cart, drawer) {
    skipSectionRefreshOnce = true;
    document.dispatchEvent(new CustomEvent('afterCartChange', { detail: { cart: cart } }));
    return refreshDrawer(drawer, getSectionHtmlFromCart(cart, drawer.dataset.sectionId));
  }

  function changeCartLine(key, quantity, drawer, callbacks) {
    if (callbacks && callbacks.beforeFetch) callbacks.beforeFetch();

    return postCartChange(key, quantity, drawer)
      .then(function (cart) {
        return applyCartChange(cart, drawer);
      })
      .catch(function () {
        return refreshDrawer(drawer);
      });
  }

  function removeCartLines(keys, drawer) {
    var updates = {};
    keys.forEach(function (key) {
      if (key) updates[key] = 0;
    });

    if (!Object.keys(updates).length) return Promise.resolve();

    drawer.classList.add('loading');

    return postCartUpdates(updates, drawer)
      .then(function (cart) {
        return applyCartChange(cart, drawer);
      })
      .catch(function () {
        return refreshDrawer(drawer);
      })
      .finally(function () {
        drawer.classList.remove('loading');
      });
  }

  function initCartLineHandlers(drawer) {
    drawer.querySelectorAll('.cart-line__wrapper[data-key]').forEach(function (line) {
      var minusBtn = line.querySelector('.cart-line__quantity-btn--minus');
      var plusBtn = line.querySelector('.cart-line__quantity-btn--plus');
      var qtyField = line.querySelector('.cart-line__quantity-value');

      if (minusBtn && plusBtn && qtyField) {
        initNumberField(plusBtn, minusBtn, qtyField);
        qtyField.addEventListener(
          'change',
          debounce(function () {
            changeCartLine(line.dataset.key, parseInt(qtyField.value, 10), drawer, {
              beforeFetch: function () {
                drawer.classList.add('loading');
              },
            });
          }, 300)
        );
      }
    });
  }

  function rebindDrawerClose(drawer) {
    drawer.querySelectorAll('.modal__backdrop, .modal__close').forEach(function (el) {
      el.addEventListener('click', function () {
        drawer.classList.remove('open');
        document.documentElement.style.overflow = '';
        setTimeout(function () {
          drawer.style.display = 'none';
        }, 100);
      });
    });
  }

  function stripThemeLineHandlers(drawer) {
    drawer.querySelectorAll('.cart-line__wrapper[data-key]').forEach(function (line) {
      var clone = line.cloneNode(true);
      if (line.parentNode) line.parentNode.replaceChild(clone, line);
    });
  }

  function reinitMinicartCore(drawer) {
    groupCartLines(drawer);
    stripThemeLineHandlers(drawer);
    initCartLineHandlers(drawer);
    rebindDrawerClose(drawer);
  }

  function refreshDrawer(drawer, sectionHtml) {
    var refreshUrl = drawer.dataset.refreshUrl;
    var refreshId = ++drawerRefreshId;

    function applyHtml(html) {
      if (refreshId !== drawerRefreshId) return 'stale';

      var parsed = parseRefreshResponse(html, drawer.dataset.sectionId);
      var doc = new DOMParser().parseFromString(parsed, 'text/html');
      var newDrawer = doc.getElementById('MinicartDrawer');

      if (!newDrawer) return 'missing';

      var previousCustomScript = drawer.querySelector('[data-minicart-custom-products]');
      var previousCustomContent = previousCustomScript ? previousCustomScript.textContent : '';

      drawer.innerHTML = newDrawer.innerHTML;
      drawer.dataset.freeShippingThreshold = newDrawer.dataset.freeShippingThreshold;
      drawer.dataset.recommendationsUrl = newDrawer.dataset.recommendationsUrl;
      drawer.dataset.shippingFreeLabel = newDrawer.dataset.shippingFreeLabel;
      drawer.dataset.shippingCalculatedLabel = newDrawer.dataset.shippingCalculatedLabel;
      drawer.dataset.engravingApplyingLabel = newDrawer.dataset.engravingApplyingLabel;
      drawer.dataset.engravingSuccessLabel = newDrawer.dataset.engravingSuccessLabel;
      drawer.dataset.engravingApplyLabel = newDrawer.dataset.engravingApplyLabel;
      drawer.dataset.recommendationsAddLabel = newDrawer.dataset.recommendationsAddLabel;
      drawer.dataset.recommendationsSource = newDrawer.dataset.recommendationsSource;
      drawer.dataset.currencyCode = newDrawer.dataset.currencyCode;
      drawer.dataset.currencySymbol = newDrawer.dataset.currencySymbol;
      drawer.dataset.sectionId = newDrawer.dataset.sectionId || drawer.dataset.sectionId;

      var fallbackScript = newDrawer.querySelector('[data-minicart-fallback-products]');
      var existingFallback = drawer.querySelector('[data-minicart-fallback-products]');

      if (fallbackScript) {
        if (existingFallback) {
          existingFallback.textContent = fallbackScript.textContent;
        } else {
          drawer.appendChild(fallbackScript.cloneNode(true));
        }
      } else if (existingFallback) {
        existingFallback.remove();
      }

      var customScript = newDrawer.querySelector('[data-minicart-custom-products]');
      var existingCustom = drawer.querySelector('[data-minicart-custom-products]');
      var nextCustomProducts = [];

      if (customScript) {
        try {
          nextCustomProducts = JSON.parse(customScript.textContent) || [];
        } catch (error) {
          nextCustomProducts = [];
        }
      }

      if (!nextCustomProducts.length && previousCustomContent) {
        if (existingCustom) {
          existingCustom.textContent = previousCustomContent;
        } else {
          var restoredCustomScript = document.createElement('script');
          restoredCustomScript.type = 'application/json';
          restoredCustomScript.setAttribute('data-minicart-custom-products', '');
          restoredCustomScript.textContent = previousCustomContent;
          drawer.insertBefore(restoredCustomScript, drawer.firstChild);
        }
      } else if (customScript) {
        if (existingCustom) {
          existingCustom.textContent = customScript.textContent;
        } else {
          drawer.appendChild(customScript.cloneNode(true));
        }
      }

      reinitMinicartCore(drawer);
      initMinicartExtras();
      initMinicartEngravingPreviews(drawer);
      initMinicartEngravingImages(drawer);
      return 'ok';
    }

    if (sectionHtml) {
      var applied = applyHtml(sectionHtml);
      if (applied === 'ok') {
        drawer.classList.remove('loading');
        return Promise.resolve();
      }
      if (applied === 'stale') {
        return Promise.resolve();
      }
    }

    if (!refreshUrl) return Promise.resolve();

    drawer.classList.add('loading');

    var bustUrl = refreshUrl + (refreshUrl.indexOf('?') === -1 ? '?' : '&') + '_=' + Date.now();

    return fetch(bustUrl, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        applyHtml(text);
      })
      .finally(function () {
        if (refreshId === drawerRefreshId) {
          drawer.classList.remove('loading');
        }
      });
  }

  function clearEngravingError(block) {
    var field = block.querySelector('[data-engraving-field="first"]');
    if (field) field.classList.remove('error');
  }

  function initMinicartEngravingPreviews(drawer) {
    if (!drawer) return;

    if (window.dAgency && typeof window.dAgency.initCombinedEngravingPreview === 'function') {
      window.dAgency.initCombinedEngravingPreview(drawer);
    }
  }

  function initMinicartEngravingImages(drawer) {
    if (!drawer) return;

    drawer.querySelectorAll('.minicart-engraving__accordion').forEach(function (details) {
      if (details.dataset.engravingImageBound === 'true') return;

      details.addEventListener('toggle', function () {
        if (!details.open) return;

        details.querySelectorAll('img').forEach(function (img) {
          img.loading = 'eager';

          if (img.dataset.src && img.src.indexOf(img.dataset.src) === -1) {
            img.src = img.dataset.src;
          }
        });
      });

      details.dataset.engravingImageBound = 'true';
    });
  }

  function getEngravingLabels(drawer) {
    return {
      applying: drawer.dataset.engravingApplyingLabel || 'Applying…',
      success: drawer.dataset.engravingSuccessLabel || 'Engraving added',
      apply: drawer.dataset.engravingApplyLabel || 'Apply engraving',
    };
  }

  function setApplyButtonState(block, state, drawer) {
    var applyBtn = block.querySelector('[data-minicart-engraving-apply]');
    var labelEl = block.querySelector('[data-minicart-engraving-apply-label]');
    if (!applyBtn || !labelEl) return;

    var labels = getEngravingLabels(drawer);

    applyBtn.disabled = state === 'loading';
    applyBtn.classList.toggle('minicart-engraving__apply--loading', state === 'loading');

    if (state === 'loading') {
      labelEl.textContent = labels.applying;
      return;
    }

    labelEl.textContent = labels.apply;
  }

  function showEngravingSuccess(block, message) {
    var successEl = block.querySelector('[data-minicart-engraving-success]');
    var messageEl = block.querySelector('[data-minicart-engraving-message]');

    if (messageEl) {
      messageEl.textContent = '';
      messageEl.classList.add('hidden');
    }

    if (successEl) {
      successEl.textContent = message || '';
      successEl.classList.toggle('hidden', !message);
    }
  }

  function showEngravingError(block, message) {
    var successEl = block.querySelector('[data-minicart-engraving-success]');
    var field = block.querySelector('[data-engraving-field="first"]');
    var messageEl = block.querySelector('[data-minicart-engraving-message]');

    if (successEl) {
      successEl.textContent = '';
      successEl.classList.add('hidden');
    }

    if (field) field.classList.add('error');

    if (messageEl) {
      messageEl.textContent = message || '';
      messageEl.classList.toggle('hidden', !message);
    }
  }

  function getCartAddUrl() {
    return getShopifyRoot() + 'cart/add.js';
  }

  function getCartChangeUrl() {
    return getShopifyRoot() + 'cart/change.js';
  }

  async function ensureMasterGroupId(lineKey, groupId) {
    var cartResponse = await fetch(getShopifyRoot() + 'cart.js');
    var cart = await cartResponse.json();
    var line = cart.items.find(function (item) {
      return item.key === lineKey;
    });

    if (!line) return;

    var properties = Object.assign({}, line.properties || {});

    if (properties._UniqueId) return;

    properties._UniqueId = groupId;

    await fetch(getCartChangeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: line.quantity,
        properties: properties,
      }),
    });
  }

  async function applyEngraving(block, drawer) {
    var line1Input = block.querySelector('[data-engraving-line="1"]');
    var line2Input = block.querySelector('[data-engraving-line="2"]');
    var applyBtn = block.querySelector('[data-minicart-engraving-apply]');

    var line1 = (line1Input && line1Input.value ? line1Input.value : '').trim();
    var line2 = (line2Input && line2Input.value ? line2Input.value : '').trim();
    var variantId = block.dataset.engravingVariantId;
    var available = block.dataset.engravingAvailable !== 'false';
    var lineKey = block.dataset.lineKey;
    var groupId = block.dataset.groupId || String(Math.floor(Math.random() * 100000));

    clearEngravingError(block);

    if (!line1 && line2) {
      showEngravingError(block, 'Please fill the first engraving line.');
      return;
    }

    if (!line1) {
      showEngravingError(block, 'Please enter engraving text.');
      return;
    }

    if (!variantId || !available) {
      showEngravingError(block, 'Engraving is currently unavailable.');
      return;
    }

    setApplyButtonState(block, 'loading', drawer);

    try {
      await ensureMasterGroupId(lineKey, groupId);

      var response = await fetch(getCartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                Engraving_line_1: line1,
                Engraving_line_2: line2,
                _UniqueId: groupId,
              },
            },
          ],
        }),
      });

      if (!response.ok) {
        var errorData = await response.json().catch(function () {
          return null;
        });
        throw new Error((errorData && (errorData.description || errorData.message)) || 'Could not add engraving.');
      }

      showEngravingSuccess(block, getEngravingLabels(drawer).success);

      document.dispatchEvent(new CustomEvent('afterCartChange'));

      await refreshDrawer(drawer);
    } catch (error) {
      showEngravingError(block, error.message || 'Could not add engraving.');
      setApplyButtonState(block, 'idle', drawer);
    }
  }

  async function addRecommendationToCart(variantId, drawer, button) {
    if (!variantId || !button || button.disabled) return;

    button.disabled = true;
    button.classList.add('minicart__recommendations-add--loading');

    try {
      var response = await fetch(getCartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(
          Object.assign(
            {
              items: [{ id: parseInt(variantId, 10), quantity: 1 }],
            },
            getSectionsPayload(drawer)
          )
        ),
      });

      var data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || data.message || 'Could not add to cart');
      }

      await applyCartChange(data, drawer);
    } catch (error) {
      button.classList.add('minicart__recommendations-add--error');
      setTimeout(function () {
        button.classList.remove('minicart__recommendations-add--error');
      }, 2000);
    } finally {
      button.disabled = false;
      button.classList.remove('minicart__recommendations-add--loading');
    }
  }

  function syncStickyAtcVisibility(drawer) {
    var hidden = !!(drawer && drawer.classList.contains('open'));

    document
      .querySelectorAll('.custom-product-hero__sticky-actions, .product-page__actions__sticky')
      .forEach(function (el) {
        el.classList.toggle('minicart-hidden-sticky-atc', hidden);
      });
  }

  function bindMinicartEvents(drawer) {
    if (!drawer || drawer.dataset.minicartEventsBound === 'true') return;

    drawer.addEventListener(
      'click',
      function (event) {
        var removeBtn = event.target.closest('.cart-line__remove');
        if (!removeBtn || !drawer.contains(removeBtn)) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var line = removeBtn.closest('.cart-line__wrapper');
        var keys = getRemoveKeysForLine(line, drawer);
        if (!keys.length) return;

        removeCartLines(keys, drawer);
      },
      true
    );

    drawer.addEventListener('click', function (event) {
      var addBtn = event.target.closest('[data-minicart-recommendations-add]');

      if (addBtn) {
        event.preventDefault();
        event.stopPropagation();
        addRecommendationToCart(addBtn.dataset.variantId, drawer, addBtn);
        return;
      }

      var applyBtn = event.target.closest('[data-minicart-engraving-apply]');
      if (!applyBtn) return;

      event.preventDefault();
      event.stopPropagation();

      var block = applyBtn.closest('[data-minicart-engraving]');
      if (block) {
        applyEngraving(block, drawer);
      }
    });

    var openObserver = new MutationObserver(function () {
      syncStickyAtcVisibility(drawer);

      if (!drawer.classList.contains('open')) return;

      var track = drawer.querySelector('[data-minicart-recommendations-track]');
      var hasSlides = track && track.querySelector('.swiper-slide');

      if (!hasSlides && (getFirstProductId(drawer) || getRecommendationsSource(drawer) === 'custom')) {
        loadRecommendations(drawer);
      }

      refreshRecommendationsCarousel(drawer);
    });

    openObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
    });

    drawer.dataset.minicartEventsBound = 'true';
    syncStickyAtcVisibility(drawer);
  }

  function initMinicartExtras() {
    var drawer = getDrawer();
    if (!drawer) return;

    bindMinicartEvents(drawer);
    updateShippingRow(drawer);
    initMinicartEngravingPreviews(drawer);
    initMinicartEngravingImages(drawer);
    waitForDrawerRefresh(drawer, function () {
      loadRecommendations(drawer);
    });
  }

  function bootMinicart() {
    var drawer = getDrawer();
    if (drawer) reinitMinicartCore(drawer);
    initMinicartExtras();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootMinicart);
  } else {
    bootMinicart();
  }

  document.addEventListener('afterCartChange', handleCartChange);

  if (!window.dAgency) window.dAgency = {};
  window.dAgency.initMinicartExtras = initMinicartExtras;
  window.dAgency.handleMinicartCartChange = handleCartChange;
})();
